import { URLS } from '@/router/routes/urlRoutes'

import LexboxRedirectView from '@/views/Lexbox/LexboxRedirectView.vue'

export const lexboxRedirectViews = [
    {
      path: `/${ URLS.AGENDA }`,
      name: URLS.AGENDA,
      component: LexboxRedirectView,
      meta: {
        requiresAuth: true,
        title: URLS.AGENDA
      }
    },
    {
      path: `/${ URLS.AGENDA }/:selectedRegisterId`,
      name: `${ URLS.AGENDA }-${ URLS.EDIT }`,
      component: LexboxRedirectView,
      props: (route: { params: { selectedRegisterId: any } }) => ({
        appointmentId: route.params.selectedRegisterId
      }),
      meta: {
        requiresAuth: true,
        title: URLS.AGENDA
      }
    },
    {
      path: `/${ URLS.EMAIL }`,
      name: URLS.EMAIL,
      component: LexboxRedirectView,
      meta: {
        requiresAuth: true,
        title: URLS.EMAIL
      }
    },
    {
      path: `/${ URLS.EMAIL }/:idEntity`,
      name: `${ URLS.EMAIL }-${ URLS.EDIT }`,
      component: LexboxRedirectView,
      meta: {
        requiresAuth: true,
        title: URLS.EMAIL
      }
    },
    {
      path: `/${ URLS.EMAIL }/new/action`,
      name: `${ URLS.EMAIL }-${ URLS.NEW }`,
      component: LexboxRedirectView,
      meta: {
        requiresAuth: true,
        title: `${ URLS.EMAIL }-${ URLS.NEW }`
      }
    },
    {
      path: `/${ URLS.EMAIL }/edit/:idAction`,
      name: `${ URLS.EMAIL }-${ URLS.ACTIONS }`,
      component: LexboxRedirectView,
      meta: {
        requiresAuth: true,
        title: URLS.EMAIL
      }
    },
]
